module.exports = __webpack_public_path__ + "img/google.346a6523.svg";